/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { SignUpErrortype } from "./interfaces";
import warningLogo from "../../assets/warning-red-logo.svg";
import { CustomButton } from "../../atoms/CustomButton";
import { login } from "../../constants/commons";
import {
  CustomButtonColor,
  CustomButtonTypes,
} from "../../atoms/CustomButton/interface";
import { triggerUserLogin } from "../../utils/helpers";

export const SignUpError: React.FC<SignUpErrortype> = (
  props: SignUpErrortype
) => {
  // On click of login
  const onLoginClick = () => {
    triggerUserLogin();
  };
  return (
    <div className="w-100 d-flex justify-content-center align-items-center flex-column">
      <img src={warningLogo} alt="" width="17%" />
      <h4 className="my-3">
        {props?.errorObj?.title
          ? props?.errorObj?.title
          : "Phone number already registered"}
      </h4>
      <div className="mb-3 error-description-style">
        {props?.errorObj?.message
          ? props?.errorObj?.message
          : "This phone number is already registered with us, login with this number to continue"}
      </div>
      <CustomButton
        className="errorcomponent-login-button-style"
        color={CustomButtonColor.PRIMARY}
        type={CustomButtonTypes.BUTTON}
        onClick={onLoginClick}
      >
        {login}
      </CustomButton>
    </div>
  );
};
